import * as Yup from 'yup'
import { EMAIL_REGEX, MIN_PASSWORD_LENGTH } from '../utils/constants';
import { CommonMessages } from '../messages/validationMessages';


// Forgot password form validation schema.
export const MYPROFILE_SCHEMA = Yup.object({
    name: Yup.string().required(CommonMessages.name_required),
    email: Yup
        .string()
        .trim()
        .matches(EMAIL_REGEX, CommonMessages.email_invalid)
        .required(CommonMessages.email_required),

});

export const CHANGE_PASSWORD_SCHEMA = Yup.object({
    oldpassword: Yup.string().trim().min(MIN_PASSWORD_LENGTH, CommonMessages.password_minimum).required(CommonMessages.oldpassword_required),
    newpassword: Yup.string().trim().min(MIN_PASSWORD_LENGTH, CommonMessages.password_minimum)
    .matches(/(?=.?[A-Z])/, CommonMessages.atleast_one_capital_letter)
    .matches(/(?=.?[a-z])/, CommonMessages.atleast_one_small_letter)
    .matches(/(?=.?[#?!@$%^&-])/, CommonMessages.atleast_one_special_character)
    .matches(/^\S*$/,  CommonMessages.should_not_contain_space)
    .required(CommonMessages.password_required),
    retypepassword: Yup.string().trim().oneOf([Yup.ref('newpassword')], CommonMessages.password_match).required(CommonMessages.password_required),
})